export const STORE_KEY = '$account'

export const CHANGE_PASSWORD = 'CHANGE_PASSWORD'
export const CHECK_EMAIL = 'CHECK_EMAIL'
export const CHECK_USERNAME = 'CHECK_USERNAME'
export const GET_ASSIGNED_PROGRAMS = 'GET_ASSIGNED_PROGRAMS'
export const LOAD_DASHBOARD = 'LOAD_DASHBOARD'
export const LOAD_PROFILE = 'LOAD_PROFILE'
export const LOGOUT = 'LOGOUT'
export const LOGIN = 'LOGIN'
export const UPDATE_PROFILE = 'UPDATE_PROFILE'
export const REQUEST_RECOVERY = 'REQUEST_RECOVERY'
export const RESET_PASSWORD = 'RESET_PASSWORD'
export const RESET_STORE = 'RESET_STORE'
export const REGISTER_ACCOUNT = 'REGISTER_ACCOUNT'

export const SAVE_USER_AFTER_LOGIN = 'SAVE_USER_AFTER_LOGIN'
export const RESET_USER_STATE = 'RESET_USER_STATE'
export const SET_PROFILE = 'SET_PROFILE'

export const GET_USER = 'GET_USER'
export const SET_USER = 'SET_USER'
export const GET_PROFILE = 'GET_PROFILE'
export const GET_PROFILE_IMAGE = 'GET_PROFILE_IMAGE'
export const SYNTHETIC_LOGIN = 'SYNTHETIC_LOGIN'

export const SET_ENTRY_REDIRECT = 'SET_ENTRY_REDIRECT'
export const GET_ENTRY_REDIRECT = 'GET_ENTRY_REDIRECT'
export const DELETE_USER = 'DELETE_USER'
